import Add from "@mui/icons-material/Add";
import ArrowForwardOutlined from "@mui/icons-material/ArrowForwardOutlined";
import Check from "@mui/icons-material/Check";
import Close from "@mui/icons-material/Close";
import CloudDone from "@mui/icons-material/CloudDone";
import CloudUpload from "@mui/icons-material/CloudUpload";
import Delete from "@mui/icons-material/Delete";
import Edit from "@mui/icons-material/Edit";
import GetApp from "@mui/icons-material/GetApp";
import Person from "@mui/icons-material/Person";
import Refresh from "@mui/icons-material/Refresh";
import Undo from "@mui/icons-material/Undo";
import VerticalAlignCenterOutlined from "@mui/icons-material/VerticalAlignCenterOutlined";
import Visibility from "@mui/icons-material/Visibility";

import type {
  BasePatientDemographics,
  MHAStatusType,
} from "@thalamos/aspire-common";
import { MhaStatus } from "@thalamos/aspire-common";

export function isValidPatientDemographics(
  basePatientDemographics: BasePatientDemographics,
): boolean {
  const nameValid =
    basePatientDemographics.name.given.trim().length > 0 &&
    basePatientDemographics.name.family.trim().length > 0;

  // We do not require a postcode for the address to be valid
  const addressValid =
    basePatientDemographics.address.address.trim().length > 0;

  return nameValid && addressValid;
}

export const getIconFromName = (iconName: string) => {
  switch (iconName) {
    case "add":
      return <Add fontSize="small" />;
    case "view":
      return <Visibility fontSize="small" />;
    case "person":
      return <Person fontSize="small" />;
    case "delete":
      return <Delete fontSize="small" />;
    case "transfer":
      return <ArrowForwardOutlined fontSize="small" />;
    case "edit":
      return <Edit fontSize="small" />;
    case "download":
      return <GetApp fontSize="small" />;
    case "upload":
      return <CloudUpload fontSize="small" />;
    case "uploadDone":
      return <CloudDone fontSize="small" />;
    case "cancel":
      return <Close fontSize="small" />;
    case "accept":
      return <Check fontSize="small" />;
    case "merge":
      return <VerticalAlignCenterOutlined fontSize="small" />;
    case "undo":
      return <Undo fontSize="small" />;
    case "amend":
      return <Refresh fontSize="small" />;
    default:
      return null;
  }
};

export function formatMhaStatus(
  status: MhaStatus,
  type?: MHAStatusType,
): string {
  switch (status) {
    case MhaStatus.Section2:
      return "Section 2";
    case MhaStatus.Section3:
      if (type === "pending-renewal") {
        return "Section 3 (renewal pending)";
      } else if (type === "pending-cto") {
        return "Section 3 (CTO pending)";
      } else {
        return "Section 3";
      }
    case MhaStatus.Section4:
      return "Section 4";
    case MhaStatus.Section5_2:
      return "Section 5(2)";
    case MhaStatus.Section5_4:
      return "Section 5(4)";
    case MhaStatus.Section17A:
      if (type === "pending-renewal") {
        return "CTO (extension pending)";
      } else {
        return "CTO";
      }
    case MhaStatus.Section136:
      return "Section 136";
    case MhaStatus.NotDetained:
      return "Not detained";
    case MhaStatus.Unknown:
      return "Unknown";
    case MhaStatus.Incomplete:
      return "Unknown (Incomplete)";
    case MhaStatus.Expired:
      return "Unknown (Expired)";
  }
}
